export default __webpack_public_path__ + "static/media/efrat_elifaz_city.f1ba60c1.jpg";